<template xmlns:v-swiper="http://www.w3.org/1999/xhtml">
  <div>
    <div class="main main-custom">
      <div class="primarylists">
        <ul class="container">
          <li>
            <table class="flex-table">
              <tr>
                <td class="lkt-title">User's Guide</td>
              </tr>
              <tr>
                <td class="lkt-title">1. Switch the display language</td>
              </tr>
              <tr>
                <td><img src="../../../static\images\en\manual-1.png" alt=""/></td>
              </tr>
              <tr>
                <td>Click on the country flag icon in the main
                menu bar at the top of the screen and use the pull-down menu to switch the
                display language.</td>
              </tr>
              <tr>
                <td class="lkt-title">2. Login</td>
              </tr>
              <tr>
                <td><img src="../../../static\images\en\manual-2.png" alt=""/></td>
              </tr>
              <tr>
                <td>①. Click the Login icon on the main menu bar
                at the top of the screen, and the login information entry pop-up window will
                appear.</td>
              </tr>
              <tr>
                <td>②. Enter the account name and password
                information on the login information entry pop-up screen.</td>
              </tr>
              <tr>
                <td>③. Click the &quot;Login&quot; button to
                complete the login process.</td>
              </tr>
              <tr>
                <td>※If you are still using the initial password,
                you will be forced to change the password after logging in, and a warning
                message will be displayed asking you to change the initial password.	</td>
              </tr>
              <tr>
                <td class="lkt-title">3. Logout</td>
              </tr>
              <tr>
                <td><img src="../../../static\images\en\manual-3.png" alt=""/></td>
              </tr>
              <tr>
                <td>While logged in, you can log out of the system
                by clicking the logout icon on the main menu bar at the top of the screen.</td>
              </tr>
              <tr>
                <td class="lkt-title">4. Course Search</td>
              </tr>
              <tr>
                <td><img src="../../../static\images\en\manual-4.png" alt=""/></td>
              </tr>
              <tr>
                <td>Enter a search term in the search input box on
                the main menu bar at the top of the screen, and click the &quot;Search&quot;
                button to display search results for courses related to your search term.</td>
              </tr>
              <tr>
                <td>The image of the search results is shown below.</td>
              </tr>
              <tr>
                <td><img src="../../../static\images\en\manual-5.png" alt=""/></td>
              </tr>
              <tr>
                <td>Click on the course you want to refer to, and
                you will be taken to the course details screen.</td>
              </tr>
              <tr>
                <td class="lkt-title">5. Change password</td>
              </tr>
              <tr>
                <td><img src="../../../static\images\en\manual-6.png" alt=""/></td>
              </tr>
              <tr>
                <td>①.Click the user icon on the main menu bar at
                the top of the screen to display the User Profile Management screen.					</td>
              </tr>
              <tr>
                <td>②.Click &quot;Change Password&quot; from the
                side menu on the left side of the screen, and the &quot;Change Password&quot;
                tab will appear on the right side.</td>
              </tr>
              <tr>
                <td>③.Enter the &quot;Current Password&quot;,
                &quot;New Password&quot;, and &quot;New Password (Confirm)&quot;, then click
                the &quot;Change&quot; button.</td>
              </tr>
              <tr>
                <td class="lkt-title">6. My Course</td>
              </tr>
              <tr>
                <td><img src="../../../static\images\en\manual-7.png" alt=""/></td>
              </tr>
              <tr>
                <td>Click the &quot;My Courses&quot; icon in the
                main menu bar at the top of the screen to go to the My Courses screen.</td>
              </tr>
              <tr>
                <td><img src="../../../static\images\en\manual-8.png" alt=""/></td>
              </tr>
              <tr>
                <td>On the &quot;My Courses&quot; screen, courses
                you have taken will be displayed in the order of their start date.</td>
              </tr>
              <tr>
                <td>※The search in the main menu bar is for the
                entire system, not just My Courses.</td>
              </tr>
              <tr>
                <td class="lkt-title">7. Course attendance</td>
              </tr>
              <tr>
                <td><i>7.1. Course Selection</i></td>
              </tr>
              <tr>
                <td><img src="../../../static\images\en\manual-9.png" alt=""/></td>
              </tr>
              <tr>
                <td>Select the course you want to study on the
                Home screen or My Courses screen, and go to the Course Overview screen.</td>
              </tr>
              <tr>
                <td><i>7.2. Content browsing</i></td>
              </tr>
              <tr>
                <td><img src="../../../static\images\en\manual-10.png" alt=""/></td>
              </tr>
              <tr>
                <td>①. On the Course Outline screen, click the
                &quot;Start Learning&quot; button to move to the Course Contents screen.</td>
              </tr>
              <tr>
                <td><img src="../../../static\images\en\manual-11.png" alt=""/></td>
              </tr>
              <tr>
                <td><img src="../../../static\images\en\manual-12.png" alt=""/></td>
              </tr>
              <tr>
                <td>②.Click on the section link in the course
                table of contents and study the content associated with the section.		</td>
              </tr>
              <tr>
                <td>③.Click on the &quot;Next&quot; or
                &quot;Previous&quot; button to switch to the next section.</td>
              </tr>
              <tr>
                <td>※When all the content under each section has
                been viewed, the section symbol will turn green.</td>
              </tr>
              <tr>
                <td>7.3. Mini test</td>
              </tr>
              <tr>
                <td><img src="../../../static\images\en\manual-13.png" alt=""/></td>
              </tr>
              <tr>
                <td>①.In chapters and sections with mini test, a mini test symbol will be
                displayed in the test column. Clicking on the test symbol (in red) will take you to the test screen.</td>
              </tr>
              <tr>
                <td><img src="../../../static\images\en\manual-14.png" alt=""/></td>
              </tr>
              <tr>
                <td>②.Check the contents of the question and
                select an answer from the choices.</td>
              </tr>
              <tr>
                <td>③.Click on the &quot;Grade&quot; button to
                submit the test.</td>
              </tr>
              <tr>
                <td><img src="../../../static\images\en\manual-15.png" alt=""/></td>
              </tr>
              <tr>
                <td>④.The scoring results will be displayed in the
                score percentage column. When all questions are answered correctly, the test mark will turn green.</td>
              </tr>
              <tr>
                <td>※ The test is not a part of the evaluation of your progress or
                performance. You can continue to take the course even if you do not take the test.</td>
              </tr>
              <tr>
                <td><i>7.4. Termination test</i></td>
              </tr>
              <tr>
                <td><img src="../../../static\images\en\manual-16.png" alt=""/></td>
              </tr>
              <tr>
                <td>①. When you have completed learning all the
                contents according to the table of contents, your progress rate will be 60%.
                Click the &quot;Exit Exam&quot; link in the sub-menu bar to display the Exit
                Exam screen.</td>
              </tr>
              <tr>
                <td><img src="../../../static\images\en\manual-17.png" alt=""/></td>
              </tr>
              <tr>
                <td>②. Click on the &quot;Start Exam&quot; button
                to start the final exam. Click the &quot;Cancel&quot; button to return to the
                Course Contents screen.</td>
              </tr>
              <tr>
                <td>※You can take the final exam as many times as
                you want. You will be judged to have passed or failed based on your
                performance in the final exam.</td>
              </tr>
              <tr>
                <td><img src="../../../static\images\en\manual-18.png" alt=""/></td>
              </tr>
              <tr>
                <td>③. Click the &quot;Previous&quot; or
                &quot;Next&quot; button to switch to the next test question. When you click
                the &quot;Submit&quot; button, you will be redirected to the response status
                confirmation screen.</td>
              </tr>
              <tr>
                <td><img src="../../../static\images\en\manual-19.png" alt=""/></td>
              </tr>
              <tr>
                <td>④. Confirm that you have answered all the
                questions on the response status confirmation screen, and then click the
                &quot;Submit&quot; button, and the confirmation dialog for submitting the
                final exam will appear.</td>
              </tr>
              <tr>
                <td>⑤. Click the &quot;OK&quot; button to submit
                your answers and finish the final exam.</td>
              </tr>
              <tr>
                <td><i>7.5. Apply for graduation</i></td>
              </tr>
              <tr>
                <td><img src="../../../static\images\en\manual-20.png" alt=""/></td>
              </tr>
              <tr>
                <td>①.Click on the &quot;Apply for
                graduation&quot; link in the sub-menu bar, and the Graduation Application screen will appear.</td>
              </tr>
              <tr>
                <td>※When you submit the questionnaire, the
                progress rate will be 99%, and the &quot;Submit&quot; screen will appear
                automatically.</td>
              </tr>
              <tr>
                <td><img src="../../../static\images\en\manual-21.png" alt=""/></td>
              </tr>
              <tr>
                <td>②. Check the progress of the course.</td>
              </tr>
              <tr>
                <td>③. When you have completed the survey, the
                &quot;Apply&quot; button will become &quot;active&quot;. When you click the
                &quot;Submit&quot; button, this course will be closed.</td>
              </tr>
              <tr>
                <td><i>7.6. List of incorrectly answered questions</i></td>
              </tr>
              <tr>
                <td><img src="../../../static\images\en\manual-22.png" alt=""/></td>
              </tr>
              <tr>
                <td>①. After completing the final exam, click on
                the &quot;Incorrect Question List&quot; link in the sub-menu bar to display
                the Incorrect Question List screen.</td>
              </tr>
              <tr>
                <td><img src="../../../static\images\en\manual-23.png" alt=""/></td>
              </tr>
              <tr>
                <td>②. You can check the correct answers and
                analysis of all incorrect answers.</td>
              </tr>
              <tr>
                <td>②. Remove from Incorrect Answers List: Remove
                the relevant question from the list of incorrect answers.</td>
              </tr>
              <tr>
                <td>③. Export Incorrect Answer List: Export all
                incorrect answers as an EXCEL file.</td>
              </tr>
              <tr>
                <td><i>7.7. Confirmation of results</i></td>
              </tr>
              <tr>
                <td><img src="../../../static\images\en\manual-24.png" alt=""/></td>
              </tr>
              <tr>
                <td>①. After completing the final exam, click on
                the &quot;Grade Analysis&quot; link in the sub-menu bar, and the Grade Status
                screen will appear.</td>
              </tr>
              <tr>
                <td><img src="../../../static\images\en\manual-25.png" alt=""/></td>
              </tr>
              <tr>
                <td>②. You can refer to your final exam score.</td>
              </tr>
              <tr>
                <td>③. Clicking on the &quot;Exam History&quot;
                link will take you to the course history screen.</td>
              </tr>
              <tr>
                <td><img src="../../../static\images\en\manual-26.png" alt=""/></td>
              </tr>
              <tr>
                <td>④. Click on the &quot;Back&quot; button to
                return to the Results screen.</td>
              </tr>
              <tr>
                <td><i>7.8. Note and note output</i></td>
              </tr>
              <tr>
                <td><img src="../../../static\images\en\manual-27.png" alt=""/></td>
              </tr>
              <tr>
                <td>①.Click the "Notes" tab in the left display area of the content learning screen to display the input area for memos. You can make a note of the contents of the relevant chapter.</td>
              </tr>
              <tr>
                <td><img src="../../../static\images\en\manual-28.png" alt=""/></td>
              </tr>
              <tr>
                <td>②. Click on the &quot;Notes Output&quot; link
                in the sub-menu bar, and you can export the notes of each chapter and section
                together as a WORD file.</td>
              </tr>
              <tr>
                <td class="lkt-title">8. Learning status - attendance status</td>
              </tr>
              <tr>
                <td><img src="../../../static\images\en\manual-29.png" alt=""/></td>
              </tr>
              <tr>
                <td>①. Click &quot;Learning Status&quot; ⇒
                &quot;Course Status&quot; menu in the main menu bar at the top of the screen
                to view the learning progress of the courses you have taken.</td>
              </tr>
              <tr>
                <td>②. Clicking on the course name symbol will
                take you to the corresponding course details screen.</td>
              </tr>
              <tr>
                <td class="lkt-title">9. Live lecture</td>
              </tr>
              <tr>
                <td><img src="../../../static\images\en\manual-30.png" alt=""/></td>
              </tr>
              <tr>
                <td>Click on the &quot;Live Lecture&quot; icon in
                the main menu bar at the top of the screen to browse the live lecture
                information.</td>
              </tr>
              <tr>
                <td>10. Progress Check (*Only for course
                administrators*)</td>
              </tr>
              <tr>
                <td><img src="../../../static\images\en\manual-31.png" alt=""/></td>
              </tr>
              <tr>
                <td>①. On the Course Summary screen, click the
                &quot;Progress Check&quot; button to move to the Progress Check screen.</td>
              </tr>
              <tr>
                <td><img src="../../../static\images\en\manual-32.png" alt=""/></td>
              </tr>
              <tr>
                <td>②. Enter the search conditions, click the
                &quot;Search&quot; button, and confirm the search results.</td>
              </tr>
              <tr>
                <td>③. Click the &quot;Export&quot; button, and
                the search results will be exported as EXCEL.</td>
              </tr>
            </table>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
//课程页轮播图
import { Swiper, SwiperSlide, directive } from "vue-awesome-swiper";
import "swiper/css/swiper.css";
import Element from "element-ui";
//国际化引入
import Vue from "vue";
import { mapMutations } from "vuex";
import { lang } from "../../assets/languages/getLanguageType.js";
Vue.prototype.$lang = lang;

export default {
  activeName: "second",
  name: "index",
  components: {
    Swiper,
    SwiperSlide,
  },
  directives: {
    swiper: directive,
  },
  props: ["userId"],
  data() {
    return {
      userIds: null,
      s1: null,
      s2: null,
      s3: null,
      s4: null,
      s5: null,
      sList: null,
      isMobileFlg: false, //設置課程分類用，手機版，下拉的顯示等
      arrowdownCss: true, //設置課程分類用，手機版，下拉的顯示等
      arrowdownIcon: true, //設置課程分類用，手機版，下拉的顯示等
      heightOut: 0, //設置課程分類用，手機版，下拉的顯示等
      heightIn: 0, //設置課程分類用，手機版，下拉的顯示等
      courseInfo: {},
      currentIndex1: -1,
      currentIndex2: -1,
      tagOne: null,
      tagTwo: null,
      loading: false,
      menuList: null,
      recommendCourse: {},
      itemList: [],
      swiperOption: {
        pagination: {
          el: ".swiper-pagination",
        },
        autoplay: {
          delay: 10000,
          disableOnInteraction: false, // 手动切换之后继续自动轮播
        },
        loop: true,
      },
    };
  },
  created() {
    //监听getMenuHeight
    window.addEventListener("resize", this.getMenuHeight);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.getMenuHeight);
  },
  mounted() {
    //获取设备屏幕的高度
    // const h = document.body.clientHeight;
    // this.$refs.indexDiv.style.height = h + "px";
    setTimeout(() => {
      const that = this;
      if (that.$refs.heightOut != undefined) {
        that.heightOut = that.$refs.heightOut.offsetHeight;
        that.heightIn = that.$refs.heightIn.offsetHeight;
        // console.log(this.heightOut)
        // console.log(this.heightIn)
        if (that.heightOut < that.heightIn) {
          that.arrowdownIcon = true;
        } else {
          that.arrowdownIcon = false;
        }
      }
    }, 2000);

    this.userIds = window.sessionStorage.getItem("id");
    this.getMenuHeight();
    this.companyId = window.sessionStorage.getItem("companyId");

    //取得首页所有课程
    this.loading = true;
    this.$api
      .post("/home/getHomeCourseInfo", {
        languageType: this.$lang(),
      })
      .then((response) => {
        this.courseInfo = response.data;
        // console.log("首页的所有课程", this.courseInfo);
        this.recommendCourse = this.courseInfo.starCourse.courseList;
        this.menuList = this.courseInfo.starCourse.menuList;
        this.sList = this.courseInfo.frontList;
        if (this.sList != null) {
          for (var k = 0; k < this.sList.length; k++) {
            if (k == 0) {
              this.s1 = this.sList[k].imagePath;
            }
            if (k == 1) {
              this.s2 = this.sList[k].imagePath;
            }
            if (k == 2) {
              this.s3 = this.sList[k].imagePath;
            }
            if (k == 3) {
              this.s4 = this.sList[k].imagePath;
            }
            if (k == 4) {
              this.s5 = this.sList[k].imagePath;
            }
          }
        }
        this.loading = false;
      });

    if (this._isMobile()) {
      this.isMobileFlg = true; //手机端
      this.arrowdownIcon = false;
    } else {
      this.isMobileFlg = false; //pc端
    }
  },
  methods: {
    //移动端：滑动功能，增加css的方式。
    //PC端：显示下拉箭头
    getMenuHeight() {
      const that = this;
      if (that.$refs.heightOut != undefined) {
        that.heightOut = that.$refs.heightOut.offsetHeight;
        that.heightIn = that.$refs.heightIn.offsetHeight;
        // console.log(this.heightOut)
        // console.log(this.heightIn)
        if (that.heightOut < that.heightIn) {
          that.arrowdownIcon = true;
        } else {
          that.arrowdownIcon = false;
        }
      }
    },
    //作用：为primarymenu增加primarymenu-add
    cssedit() {
      this.arrowdownCss = !this.arrowdownCss;
    },

    //作用：判断终端设备
    _isMobile() {
      let flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      );
      return flag;
    },

    handleClick(el, a, b) {
      // console.log(el, a, b);
    },
    explore: function () {
      // 用 #explore 添加锚点
      let jump = document.querySelectorAll("#explore");
      let total = jump[0].offsetTop;
      let distance = document.getElementById("app").scrollTop;
      // 平滑滚动，时长500ms，每10ms一跳，共50跳
      let step = total / 50;
      if (total > distance) {
        smoothDown();
      } else {
        let newTotal = distance - total;
        step = newTotal / 50;
        smoothUp();
      }

      function smoothDown() {
        if (distance < total) {
          distance += step;
          document.getElementById("app").scrollTop = distance;
          setTimeout(smoothDown, 10);
        } else {
          document.getElementById("app").scrollTop = total;
        }
      }

      function smoothUp() {
        if (distance > total) {
          distance -= step;
          document.getElementById("app").scrollTopp = distance;
          setTimeout(smoothUp, 10);
        } else {
          document.getElementById("app").scrollTop = total;
        }
      }
    },
    go_regist: function () {
      this.$emit("info", "regist");
    },
    goRouter: function (url, tagOneId) {
      if (tagOneId) {
        this.$router.push({
          path: url,
          query: {
            tagOne: tagOneId,
          },
        });
      } else {
        this.$router.push(url);
      }
    },
    begin_start: function () {
      // console.log(document.getElementById("2"));
      //this.$router.push("/home/personSet");
    },
    ...mapMutations("header", ["setHistory"]),
    go_course: function (item, collegeId) {
      this.userIds = window.sessionStorage.getItem("id");
      if (this.userIds == "" || this.userIds == null) {
        this.$alert(window.vm.$i18n.t("js.PleaseLogin"), "", {
          confirmButtonText: window.vm.$i18n.t("js.confirm"),
        });
        return;
      } else {
        window.sessionStorage.setItem("courseGOBackNum", 1);
        this.setHistory("/home");
        this.$router.push({
          name: "Aicourse",
          query: {
            buyCourseId: item.courseId,
            buyCollegeId: collegeId,
          },
        });
      }
    },

    secondMenuChange: function (index1, id) {
      if (this.tagTwo == id) {
        return;
      }
      this.tagTwo = id;
      let allFlag = 1;
      if (id === -1) {
        //如果二级分类为-1，那就把一级id传给后台
        this.tagTwo = this.courseInfo.courses[index1].id;
        allFlag = 1;
      } else {
        allFlag = 0;
      }
      this.tagOne = this.courseInfo.courses[index1].id;
      this.loading = true;
      this.companyId = window.sessionStorage.getItem("companyId");
      this.$api
        .post("/home/getHomeCourseInfoChild", {
          id: this.tagTwo,
          allFlag: allFlag,
          languageType: this.$lang(),
        })
        .then((response) => {
          // console.log(response.data.courseList)
          this.courseInfo.courses[index1].courseList = response.data.courseList;
          this.loading = false;
        });
    },
    mouseOverUp($event) {
      $event.currentTarget.className = "el-icon-arrow-up oaa";
    },
    mouseLeaveUp($event) {
      $event.currentTarget.className = "el-icon-arrow-up up_laa";
    },
    mouseOverDown($event) {
      $event.currentTarget.className = "el-icon-arrow-down oaa";
    },
    mouseLeaveDown($event) {
      $event.currentTarget.className = "el-icon-arrow-down down_laa";
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.main {
  padding-top: 60px;
}

a {
  text-decoration: none;
  color: white;
  -webkit-tap-highlight-color: white;
  -webkit-user-select: none;
  -moz-user-focus: none;
  -moz-user-select: none;
}
.l {
  float: left;
}
.r {
  float: right;
}
.clear::after {
  content: ".";
  display: block;
  clear: both;
  height: 0;
  visibility: hidden;
}
.container,
.bigCourse {
  width: 1200px;
  margin: 0 auto;
}

@media screen and (min-width: 1000px) and (max-width: 1200px) {
  .container,
  .bigCourse {
    width: 1000px;
  }
}
@media screen and (min-width: 800px) and (max-width: 1000px) {
  .container,
  .bigCourse {
    width: 800px;
  }
}
@media screen and (min-width: 600px) and (max-width: 800px) {
  .container,
  .bigCourse {
    width: 600px;
  }
}
@media screen and (max-width: 600px) {
  .container,
  .bigCourse {
    width: 400px;
  }
}
.swiper-container {
  margin-bottom: 20px;
  position: relative;
  /* overflow: hidden;
    height: 450px; */
}
.swiper-container img {
  width: 100%;
}

.primarylists {
  padding-top: 10px;
}

.primarylists > ul > li {
  padding-bottom: 20px;
  width: 1210px;
  overflow: hidden;
}
.primarylists ul li .titles {
  height: 35px;
  width: 1000px; /* 需要配合JS动态设置宽度 */
  padding-bottom: 5px;
  color: black;
  margin-bottom: 10px;
  display: flex;
  inline-size: max-content;
}

.secondlists {
  padding-left: 30px;
}
.secondlists > ul > li {
  padding-bottom: 10px;
  overflow: hidden;
}

.secondlists ul li .titles {
  height: 35px;
  width: 1000px; /* 需要配合JS动态设置宽度 */
  padding-bottom: 5px;
  padding-left: 5px;

  color: black;
  margin-bottom: 5px;
  display: flex;
  inline-size: max-content;
}

.secondlists ul li .titles .title {
  font-size: 22px;
  text-decoration: underline;
  line-height: 35px;
  font-weight: bold;
}

.secondlists ul li img {
  height: auto;
  width: 100%;
  margin-top: 10px;
  overflow: hidden;
}

.secondlists ul li p {
  font-size: 14px;
  margin-top: 10px;
}

.thirdlists {
  padding-left: 30px;
}
.thirdlists > ul > li {
  padding-bottom: 10px;
  padding-left: 30px;
  overflow: hidden;
}

.thirdlists ul li .titles {
  height: 35px;
  width: 1000px; /* 需要配合JS动态设置宽度 */
  padding-bottom: 5px;
  padding-left: 5px;
  color: black;
  margin-bottom: 5px;
  display: flex;
  inline-size: max-content;
}

.thirdlists ul li .titles .title {
  font-size: 22px;
  text-decoration: underline;
  line-height: 35px;
  font-weight: bold;
}

.thirdlists ul li img {
  height: auto;
  width: 100%;
  margin-top: 10px;
  overflow: hidden;
}

.thirdlists ul li p {
  font-size: 14px;
  margin-top: 10px;
}

.primarylists ul li .titles img {
  width: 32px;
  height: 32px;
  margin-top: 1px;
}
.primarylists ul li .titles .title {
  font-size: 24px;
  padding: 0 20px 0 10px;
  line-height: 35px;
  font-weight: bold;
}

.primarylists ul li .titles .more {
  font-size: 16px;
  line-height: 35px;
  cursor: pointer;
  padding-right: 20px;
}
.primarylists ul li .titles .more a {
  color: black;
}

.primarylists .secondlist {
  height: 100%;
  font-size: 16px;
}
.primarylists .secondlist ul li {
  float: left;
  padding: 3px 10px;
  cursor: pointer;
  margin-right: 16px;
  background: #666;
  border-radius: 15px;
  color: white;
}
.primarylists .secondlist ul li.choose {
  background: lightskyblue;
}

.primarylists .lessons ul {
  height: 350px;
  overflow: hidden;
  transform: translateX(5px);
}

.primarylists .lessons ul li {
  width: 190px;
  height: 170px;
  float: left;
  box-sizing: border-box;
  background: #333;
  background-clip: padding-box;
  margin-right: 10px;
  margin-bottom: 10px;
  border-radius: 10px;
  overflow: hidden;
}
.primarylists .lessons ul li:nth-of-type(1) {
  width: 390px;
  height: 350px;
}
.primarylists .lessons ul li:nth-of-type(1) .img {
  height: 200px;
}
.primarylists .lessons ul li .img {
  height: 100px;
  width: 100%;
  overflow: hidden;
}
.primarylists .lessons ul li .img img {
  width: 100%;
  transition: all 0.25s ease-in-out;
  -moz-transition: all 0.25s ease-in-out;
  -webkit-transition: all 0.25s ease-in-out;
  -o-transition: all 0.25s ease-in-out;
}
.primarylists .lessons .lessontitle {
  padding: 0px 10px;
  margin: 8px 0 3px;
  color: #f8f8f8;
  font-size: 15px;
  cursor: pointer;
  /* 1行溢出隐藏 */
  display: -webkit-box;
  /*! autoprefixer: off */
  -webkit-box-orient: vertical;
  /* autoprefixer: on */
  -webkit-line-clamp: 1;
  overflow: hidden;
}
.primarylists .lessons .lessontitle:hover {
  color: lightskyblue;
}
.primarylists .lessons .introduce {
  padding: 0 10px;
  color: #999;
  font-size: 12px;

  /* 1行溢出隐藏 */
  display: -webkit-box;
  /*! autoprefixer: off */
  -webkit-box-orient: vertical;
  /* autoprefixer: on */
  -webkit-line-clamp: 1;
  overflow: hidden;
}

.primarylists .lessons .islike {
  float: right;
  margin: 2px 10px 3px 0px;
  color: #f8f8f8;
  font-size: 10px;
  cursor: pointer;
  overflow: hidden;
}

.primarylists .lessons .islike span {
  float: right;
}

.primarylists .lessons ul li:nth-of-type(1) .lessontitle {
  font-size: 16px;
  padding: 15px 20px 0 20px;
  /* 2行溢出隐藏 */
  display: -webkit-box;
  /*! autoprefixer: off */
  -webkit-box-orient: vertical;
  /* autoprefixer: on */
  -webkit-line-clamp: 2;
  overflow: hidden;
}

.primarylists .lessons ul li:nth-of-type(1) .introduce {
  font-size: 14px;
  line-height: 24px;
  padding: 10px 20px 0 20px;
  /* 3行溢出隐藏 */
  display: -webkit-box;
  /*! autoprefixer: off */
  -webkit-box-orient: vertical;
  /* autoprefixer: on */
  -webkit-line-clamp: 3;
  overflow: hidden;
}

.footer {
  padding: 50px 0 30px 0;
  color: white;
  text-align: center;
  background: url(../../../static/images/bg/myCourseBackgroundFoot.jpg)
    no-repeat center bottom;
  background-size: cover;
}
.footer .line1 {
  font-size: 46px;
}
.footer .line2 {
  font-size: 14px;
  margin-bottom: 30px;
}
.footer .line3 {
  display: inline-block;
  padding: 5px 50px;
  border: 1px solid white;
  border-radius: 20px;
}
.footer .line3:hover {
  background: white;
  color: black;
  cursor: pointer;
}
.header {
  height: 60px;
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
  background: #121212;
  color: white;
  z-index: 10;
  opacity: 0.8;
}
.header ul li {
  float: left;
  margin-right: 30px;
}
.header .logo {
  padding-top: 12px;
  cursor: pointer;
}
.header .logo img {
  height: 36px;
}
.header ul li div {
  height: 12px;
  font-size: 12px;
  position: relative;
}
.header ul li:hover div {
  color: #999;
}
.header ul li div span {
  height: 16px;
  width: 16px;
  line-height: 16px;
  text-align: center;
  background: red;
  color: white;
  display: block;
  border-radius: 50%;
  position: absolute;
  bottom: -8px;
  right: -18px;
}
.header ul li p {
  padding-top: 5px;
  font-size: 20px;
  text-align: center;
  color: #409eff;
}

.header .right {
  padding-top: 10px;
}
.header .right .user > div {
  margin-right: 10px;
}
.header .right .user .photo {
  height: 40px;
  width: 40px;
  border-radius: 50%;
  overflow: hidden;
  cursor: pointer;
}
.header .right .user .photo img {
  width: 100%;
}
.header .right .user .name,
.header .right .user .logout {
  font-size: 22px;
  height: 40px;
  line-height: 40px;
  cursor: pointer;
}
.header .right .user .name:hover,
.header .right .user .logout:hover {
  color: #999;
}

.header .right .search {
  margin: 0 20px;
  font-size: 22px;
  height: 40px;
  line-height: 40px;
  cursor: pointer;
}
.header .right .search:hover {
  color: #999;
}
.header .right .flag {
  height: 40px;
  width: 60px;
  cursor: pointer;
  overflow: hidden;
  border-radius: 5px;
}
.header .right .flag img {
  width: 100%;
}
.swiper_bottom_shade {
  position: absolute;
  bottom: 0;
  left: 0;
  z-index: 10;
  height: 200px;
  width: 100%;
  background: -webkit-gradient(
    linear,
    left top,
    left bottom,
    from(rgba(224, 224, 219, 0)),
    to(#fff)
  );
  background: -webkit-linear-gradient(top, rgba(224, 224, 219, 0), #fff 100%);
  background: linear-gradient(180deg, rgba(224, 224, 219, 0), #fff 100%);
}
.bigCourse {
  position: relative;
}
.bigCourse ul {
  /*background-color: rgba(255,255,255,0.7);*/
  /*border-radius: 10px;*/
  /*padding: 30px 2% 0;*/
  width: 98%;
  margin: 0 1%;
  /*position: absolute;*/
  /*bottom: 10px;*/
  /*z-index: 9;*/
}

.bigCourse li a {
  font-size: 14px;
  background-image: -webkit-linear-gradient(315deg, #02adff 0%, #00d3ff 100%);
  background-image: linear-gradient(135deg, #02adff 0%, #00d3ff 100%);
  padding: 5px 15px;
  border-radius: 5px;
  margin-right: 20px;
  float: left;
  margin-bottom: 10px;
}
.bigCourse li a:hover {
  background-image: -webkit-linear-gradient(315deg, #00d3ff 0%, #02adff 100%);
  background-image: linear-gradient(135deg, #00d3ff 0%, #02adff 100%);
}
.showAllCourse {
  position: absolute;
  right: 10px;
  top: 5px;
  cursor: pointer;
}
.showAllCourse img {
  width: 19px;
}
/* .showAllCourse i{*/
/*  font-size: 20px;*/
/*   font-weight: bold;*/
/*   color: #666;*/
/*}*/
/*.showAllCourse i :hover{*/
/*  color: #02ADFF;*/
/*}*/
.primarymenu-add {
  height: 39px;
  overflow: hidden;
}
.boxout {
}
.boxout .boxin {
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  overflow-x: scroll;
  overflow-y: hidden;
  white-space: nowrap;
}
.boxout .boxin li.SchoolBusiness_menu_li {
  box-sizing: border-box;
}
::-webkit-scrollbar {
  display: none;
}

.el-tabs >>> .el-tabs__active-bar {
  height: 30px;
  background-color: #02adff;
  border-radius: 25px;
  padding: 0 20px;
  margin-left: -20px;
  margin-bottom: 5px;
}
.el-tabs >>> .el-tabs__item {
  z-index: 2;
}
.el-tabs >>> .el-tabs__nav-wrap:after {
  height: 0px;
  background-color: none;
}
.el-tabs >>> .el-tabs__nav-scroll {
  padding: 0 20px;
}
.el-tabs >>> .el-tabs__item.is-active {
  color: #fff;
}
.el-tabs >>> .toolbar {
  padding-top: 20px;
}
.el-tabs >>> .el-pager {
  margin: 0 10px;
}
.vaa :hover {
  transform: scale(1.05, 1.05);
  cursor: pointer;
}
.down_laa {
  -webkit-text-stroke-width: 2px;
  color: #999;
}
.up_laa {
  -webkit-text-stroke-width: 2px;
  color: #00d3ff;
}
.oaa {
  -webkit-text-stroke-width: 2px;
  color: #ffb821;
}
.target-fix {
  position: relative;
  top: -60px;
  display: block;
  height: 0;
  overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// src/views/index/manual_en.vue